export enum CategoryTypes {
  MAIN_CATEGORY = "Category",
  SUB_CATEGORY = "SubCategory",
  SUB_CHILD_CATEGORY = "SubSubCategory"
}

export enum AttributeTypes {
  Required = "Required",
  Related = "Related",
  Additional = "Additional"
}

export enum ApiRoutesCategories {
  CategoryPriority = "category-admin/priority",
  Category = "category-admin",
  CategoryWithPermissions = "category-admin/with-permissions",
  MainCategory = "category-admin/main",
  SubCategory = "category-admin/sub",
  SubChildCategory = "category-admin/sub-sub",
  AllCategories = "category-admin/all",
  ChildCategories = "category-admin/child"
}
